import { QueryClient, QueryClientProvider } from '@w/react-query'
import { I18nProvider, setLocale } from './i18n'
import { PlatformShell } from '@w/ui/system/platform-shell'
import type { StoryShellProps } from '@w/ui/storybook'
import { useStorybookUrlSettings } from '@w/ui/storybook'
import { useEffect } from 'react'

const queryClient = new QueryClient()

export function StorybookShell(props: StoryShellProps) {
  const [, setSettings] = useStorybookUrlSettings()
  // Sync storybook language setting with i18n
  useEffect(() => {
    setLocale(props.settings.language)
  }, [props.settings.language])

  const content = <I18nProvider>
    <QueryClientProvider client={queryClient}>
      {props.children}
    </QueryClientProvider>
  </I18nProvider>
  // Retained appearance stories supply their own PlatformShell and user-scoped theme.
  // Two providers writing documentElement on mount make the host overwrite restored app preferences.
  if (props.params?.themeOwnership === 'story') return content

  return (
    <PlatformShell
      minimal={props.settings.minimal}
      reverseTheme={props.settings.reversedTheme}
      sourceColor={props.settings.sourceColor}
      onMinimalChange={(minimal) => {
        setSettings((current) => ({ ...current, minimal }))
      }}
      onSourceColorChange={(sourceColor) => {
        setSettings((current) => ({ ...current, sourceColor }))
      }}
    >
      {content}
    </PlatformShell>
  )
}
